import React, { SelectHTMLAttributes } from 'react';
import Select from '../Select/Select';
import IconButton from '#/components/Form/IconButton/IconButton';
import { TLayout, TSelectedAlbumType } from '#/redux/reducers/artistAlbums';
import { twMerge } from 'tailwind-merge';

const iconButtonStyle =
  'text-theme-light-gray hover:bg-theme-gray hover:text-theme-white pointer-events-auto';

const selectedIconButtonStyle = 'bg-theme-gray text-theme-white';

const iconStyle = 'text-lg p-1';

interface IProperties {
  albumType: TSelectedAlbumType;
  layout: TLayout;
  onChangeSelectedAlbumType: SelectHTMLAttributes<HTMLSelectElement>['onChange'];
  onClickLayoutType: (type: TLayout) => void;
}

const Filters = (properties: IProperties) => {
  const { albumType, layout, onChangeSelectedAlbumType, onClickLayoutType } =
    properties;
  return (
    <div className="flex gap-2">
      <Select
        options={[
          { text: 'All', value: '' },
          { text: 'Albums', value: 'album' },
          { text: 'Singles and EPs', value: 'single' },
          { text: 'Compilations', value: 'compilation' },
        ]}
        onChange={onChangeSelectedAlbumType}
        value={albumType}
      />
      <IconButton
        className={
          layout === 'detailed'
            ? twMerge(iconButtonStyle, selectedIconButtonStyle)
            : iconButtonStyle
        }
        iconClassName={iconStyle}
        icon="format_list_bulleted"
        onClick={() => onClickLayoutType('detailed')}
      />
      <IconButton
        className={
          layout === 'grid'
            ? twMerge(iconButtonStyle, selectedIconButtonStyle)
            : iconButtonStyle
        }
        iconClassName={iconStyle}
        icon="grid_view"
        onClick={() => onClickLayoutType('grid')}
      />
    </div>
  );
};

export default Filters;
